import {
    FETCH_PROCEDURES_LIST_REQUEST,
    FETCH_PROCEDURES_LIST_SUCCESS,
    FETCH_PROCEDURES_LIST_FAILURE,
  } from "./FetchProceduresListTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchProceduresListRequest = () => {
    return {
      type: FETCH_PROCEDURES_LIST_REQUEST,
    };
  };
  
  export const fetchProceduresListSuccess = (proceduresList) => {
    return {
      type: FETCH_PROCEDURES_LIST_SUCCESS,
      payload: proceduresList,
    };
  };
  
  export const fetchProceduresListFailure = (error) => {
    return {
      type: FETCH_PROCEDURES_LIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchProceduresList = (page, payload, typeCode) => {
    //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/procedure/list/fetch?pageSize=5&page=" + page + "&typeCode="+ typeCode;

    if(payload && payload.search_filter && payload.search_key){
      url += "&"+ payload.search_filter+ "=" + payload.search_key;
    }
    return async (dispatch) => {
      dispatch(fetchProceduresListRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
  
        const proceduresList = response.data.data;
        dispatch(fetchProceduresListSuccess(proceduresList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchProceduresListFailure(errorMsg));
      }
    };
  };
  